import React, { memo } from 'react';
import { LazySearchBox, LazySearchTypeAhead } from '../lazyLoad/LazyLoadSearchImports';
import LazyLoadComponent from '../../global/lazyLoad/LazyLoadComponent';

const GlobalSearch = () => {
    return (
        <>
            {window.location.pathname.includes('/search/') ? (
                <LazyLoadComponent fallback={<></>}>
                    <LazySearchBox />
                </LazyLoadComponent>
            ) : (
                <LazyLoadComponent fallback={<></>}>
                    <LazySearchTypeAhead />
                </LazyLoadComponent>
            )}
        </>
    );
};

export default GlobalSearch;
